'use strict';

angular.module('mean.general-tasks').factory('tradeCodeService', ['$filter', 'TradeCodes', '$window', '$q',
  function ($filter, TradeCodes, $window, $q) {
    var getNameLogic = function (id) {
      var dataVal2 = $window.localStorage.getItem('arrayLogic');
      dataVal2 = JSON.parse(dataVal2);
      var filterVal2 = dataVal2.filter(item => item.code === id);
      return (filterVal2.length == 1)?filterVal2[0].name:null;
    };
    var getCodeLogic = function (trade) {
      var dataVal = $window.localStorage.getItem('arrayLogic');
      dataVal = JSON.parse(dataVal);
      var filterVal = dataVal.filter(item => item.name === trade);
      return (filterVal.length == 1)?filterVal[0].code:null;
    };

    var updateOrGetTradeData = function () {
      var arrayLogic = [];
      var stringLogic = [];
      var codeLogic = [];
      var deferred = $q.defer();
      TradeCodes.query({ type: 'arrayLogic' }, function (data) {
        data.forEach(element => {
          arrayLogic.push({
          'name': element.name,
          'value': element.code.toString(),
          'code': element.code.toString()
        });
          stringLogic.push(element.name);
          codeLogic.push(element.code.toString());
        });
        $window.localStorage.setItem('arrayLogic', JSON.stringify(arrayLogic));
        $window.localStorage.setItem('stringLogic', JSON.stringify(stringLogic));
        $window.localStorage.setItem('codeLogic', JSON.stringify(codeLogic));
        deferred.resolve();
      });
      return deferred.promise;
    }

    var getArrayLogic = function () {
      var arrVal = $window.localStorage.getItem('arrayLogic');
      return JSON.parse(arrVal);
    };
    var getArrayStringsLogic = function () {
      var data = $window.localStorage.getItem('stringLogic');
      return JSON.parse(data);
    };
    var getArrayCodesLogic = function () {
      var data2 = $window.localStorage.getItem('codeLogic');
      return JSON.parse(data2);
    };
    return {
      getName: getNameLogic,
      getCode: getCodeLogic,
      getArray: getArrayLogic,
      getArrayStrings: getArrayStringsLogic,
      getArrayCodes: getArrayCodesLogic,
      updateTrades: updateOrGetTradeData
    };
  }
]);




// WEBPACK FOOTER //
// ./packages/custom/general-tasks/public/services/tradeCodeService.js